import React from 'react';
import styles from './ccf-customer-card-profile-info.module.scss';
import { activeContactSelector } from '../../ccf-inbox.slice';
import { useSelector } from 'react-redux';
import { useTranslator } from '@nice-ccf/ui-controls';

/* eslint-disable-next-line */
export interface CcfCustomerProfileInfoProps {}

/**
 * CcfCustomerProfileInfo - used to display profile info of active contact
 * @param props --?- CcfCustomerProfileInfoProps
 * @example <CcfCustomerProfileInfo />
 */
export function CcfCustomerProfileInfo(props?: CcfCustomerProfileInfoProps) {
  const profileData = useSelector(activeContactSelector);
  const [translate] = useTranslator();

  return (
    <section className={styles.profileInfo}>
      {profileData && (
        <>
          <div className={styles.accountId}>
            <span>
              {translate('account')}# {profileData.id}
            </span>
          </div>
          <div className={styles.accountName}>
            <strong>
              {[
                profileData?.customer?.firstName,
                profileData?.customer?.middleName,
                profileData?.customer?.lastName,
              ]
                .filter(Boolean)
                .join(' ')}
            </strong>
          </div>
          <div style={{ paddingBottom: '8px' }}>
            <a
              target="_blank"
              href={profileData.crmUrl}
              className={styles.viewCRmLink}
            >
              {profileData?.crmLabel}
            </a>
          </div>
        </>
      )}
      <div className={styles.bottomBorder}></div>
    </section>
  );
}

export default CcfCustomerProfileInfo;
